import React, {useState, useEffect, useRef} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {Helmet} from "react-helmet-async";
import {Login, Register, ForgotPassword, VerifyOTP, ResetPassword} from "../services/auth";
import {admin_role_id, contractor_role_id, next_app, super_admin_role_id} from "../constant";
import {sweetAlerts} from "../utils/sweet-alerts";
import {GoogleAddress} from "../components/GoogleAddress";

import {Form, Formik} from "formik";
import * as Yup from "yup";
import Alert from "@mui/material/Alert";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

import {
	PendingBusinessVerificationPromptService,
	PendingSendEmailChangeOtpService,
	PendingSendPhoneChangeOtpService,
	PendingUpdateSignupService,
	PendingVerifyEmailChangeOtpService,
	PendingVerifyPhoneChangeOtpService,
} from "../services/pendingAuthUpdate";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { navigateToNextWithSync } from "../utils/syncUtils";

const LoginPage = () => {
	const location = useLocation();
	const isSignupPath = location.pathname === "/signup";
	// var addressStr = null;

	const [activeTab, setActiveTab] = useState("signin");
	const [showPassword, setShowPassword] = useState(false);
	// const [userType, setUserType] = useState("contractor");
	// // const [firstname, setFirstname] = useState("");
	// const [lastname, setLastname] = useState("");
	// const [email, setEmail] = useState("");
	// const [password, setPassword] = useState("");
	// const [confirmPassword, setConfirmPassword] = useState("");
	// const [phone, setPhone] = useState("");
	// const [address, setAddress] = useState("");
	// const [businessName, setBusinessName] = useState("");
	// const [addressString, setAddressString] = useState("");
	const [errors, setErrors] = useState({});
	const [loginEmail, setLoginEmail] = useState("");
	const [loginPassword, setLoginPassword] = useState("");
	// const [apiError, setApiError] = useState("");
	const [otp, setOtp] = useState("");
	const [newPassword, setNewPassword] = useState("");
	const [confirmNewPassword, setConfirmNewPassword] = useState("");
	const [otpSent, setOtpSent] = useState(false);
	const [otpVerified, setOtpVerified] = useState(false);
	const [showPasswordReset, setShowPasswordReset] = useState(false);
	// const [termsAccepted, setTermsAccepted] = useState(false);
	// const [profileImage, setProfileImage] = useState(null);
	// const [profileImagePreview, setProfileImagePreview] = useState(null);

	// const [isOpen, setIsOpen] = useState(false);
	// const navigate = useNavigate();

	useEffect(() => {
		// Check URL parameters to set initial state
		const urlParams = new URLSearchParams(location.search);
		const tab = urlParams.get("tab");
		const type = urlParams.get("type");

		if (tab === "signup") {
			setActiveTab("signup");
		}
		if (tab === "forgot_password") {
			setActiveTab("forgot_password");
		}
		if (isSignupPath) {
			setActiveTab("signup");
		}
	}, [location.search]);

	useEffect(() => {
		// Add any scroll animations or other effects here
		document.body.style.overflow = "hidden";
		return () => {
			document.body.style.overflow = "auto";
		};
	}, []);

	const toggleTab = (tab) => {
		setActiveTab(tab);
	};

	const handleLogin = async () => {
		try {
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			let valid = true;
			let newErrors = {email: "", password: "", api: ""};

			if (!loginEmail) {
				newErrors.email = "Email is required";
				valid = false;
			} else if (!emailRegex.test(loginEmail)) {
				newErrors.email = "Enter a valid email address";
				valid = false;
			}

			if (!loginPassword) {
				newErrors.password = "Password is required";
				valid = false;
			}

			if (!valid) {
				setErrors(newErrors);
				return;
			}
			const submitBtn = document.querySelector(".submit-btn");
			if (submitBtn) {
				submitBtn.disabled = true;
				submitBtn.textContent = "Sign in...";
			}
			const response = await Login({email: loginEmail, password: loginPassword});
			if (response.status === true && response.data) {
				try {
					const RoleString = response.data.role === "super-admin" ? super_admin_role_id : response.data.role === "admin" ? admin_role_id : contractor_role_id;

					localStorage.setItem("auth_token", response.data.token);
					localStorage.setItem("is_login", true);
					localStorage.setItem("first_name", response.data.first_name);
					localStorage.setItem("last_name", response.data.last_name);
					localStorage.setItem("profile_image", response.data.profile_image);
					localStorage.setItem("role", RoleString);
					localStorage.setItem("verified", response.data.verified);
					localStorage.setItem("trusted", response.data.trusted);
					localStorage.setItem("badge", response.data.badge || false);

					// Force page reload to ensure App component picks up the new role
					if (response.data.role === "contractor") {
						// window.location.href = HOME_URL + "/contractor-dashboard";
						window.location.href = "/contractor-dashboard";
					}
					if (response.data.role === "super-admin") {
						// window.location.href = HOME_URL + "/admin-dashboard";
						window.location.href = "/admin-dashboard";
					}
					if (response.data.role === "admin") {
						// window.location.href = HOME_URL + "/admin-dashboard";
						window.location.href = "/admin-dashboard";
					}
				} catch (err) {
					const submitBtn = document.querySelector(".submit-btn");
					if (submitBtn) {
						submitBtn.disabled = false;
						submitBtn.textContent = "Sign in";
					}
				}
			}
			if (response.status !== true) {
				if (response?.data?.need_to === "verified_mail") {
					// window.location.href = HOME_URL + `/verify-email?uuid=${response?.data?.user_uuid}`;
					window.location.href = `/verify-email?uuid=${response?.data?.user_uuid}`;
				}
				const submitBtn = document.querySelector(".submit-btn");
				if (submitBtn) {
					submitBtn.disabled = false;
					submitBtn.textContent = "Sign in";
				}
				setErrors({...newErrors, api: response.message || "Login failed. Please try again."});
			}
		} catch (error) {
			const submitBtn = document.querySelector(".submit-btn");
			if (submitBtn) {
				submitBtn.disabled = false;
				submitBtn.textContent = "Sign in";
			}
		}
	};

	const handleForgotPassword = async () => {
		try {
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			let valid = true;
			let newErrors = {email: "", api: ""};

			if (!loginEmail) {
				newErrors.email = "Email is required";
				valid = false;
			} else if (!emailRegex.test(loginEmail)) {
				newErrors.email = "Enter a valid email address";
				valid = false;
			}

			if (!valid) {
				setErrors(newErrors);
				return;
			}

			// Clear previous errors
			setErrors({});

			// Show loading state
			const submitBtn = document.querySelector(".submit-btn");
			if (submitBtn) {
				submitBtn.disabled = true;
				submitBtn.textContent = "Sending...";
			}

			const response = await ForgotPassword({email: loginEmail});

			if (response.status === true) {
				setErrors({});
				setOtpSent(true);
				setShowPasswordReset(false);
			} else {
				setErrors({...newErrors, api: "Failed to send Code. Please try again."});
			}
		} catch (error) {
			console.error("Forgot password error:", error);
			setErrors({api: "Network error. Please try again."});
		} finally {
			// Reset button state
			const submitBtn = document.querySelector(".submit-btn");
			if (submitBtn) {
				submitBtn.disabled = false;
				submitBtn.textContent = "Send Code";
			}
		}
	};

	const handleVerifyOTP = async () => {
		try {
			let newErrors = {otp: "", api: ""};

			if (!otp) {
				newErrors.otp = "Code is required";
				setErrors(newErrors);
				return;
			}

			if (otp.length !== 6) {
				newErrors.otp = "Code must be 6 digits";
				setErrors(newErrors);
				return;
			}

			// Clear previous errors
			setErrors({});

			// Show loading state
			const submitBtn = document.querySelector(".submit-btn");
			if (submitBtn) {
				submitBtn.disabled = true;
				submitBtn.textContent = "Verifying...";
			}

			const response = await VerifyOTP({
				email: loginEmail,
				otp: otp,
			});

			if (response.status === true) {
				setErrors({});
				setOtpVerified(true);
				setShowPasswordReset(true);
			} else {
				setErrors({...newErrors, api: response.message || "Invalid Code. Please try again."});
			}
		} catch (error) {
			console.error("Code verification error:", error);
			setErrors({api: "Network error. Please try again."});
		} finally {
			// Reset button state
			const submitBtn = document.querySelector(".submit-btn");
			if (submitBtn) {
				submitBtn.disabled = false;
				submitBtn.textContent = "Verify Code";
			}
		}
	};

	const handleResetPassword = async () => {
		try {
			let newErrors = {newPassword: "", confirmNewPassword: "", api: ""};
			let valid = true;

			if (!newPassword) {
				newErrors.newPassword = "New password is required";
				valid = false;
			} else if (newPassword.length < 6) {
				newErrors.newPassword = "Password must be at least 6 characters";
				valid = false;
			}

			if (!confirmNewPassword) {
				newErrors.confirmNewPassword = "Please confirm your password";
				valid = false;
			} else if (confirmNewPassword !== newPassword) {
				newErrors.confirmNewPassword = "Passwords do not match";
				valid = false;
			}

			if (!valid) {
				setErrors(newErrors);
				return;
			}

			// Clear previous errors
			setErrors({});

			// Show loading state
			const submitBtn = document.querySelector(".submit-btn");
			if (submitBtn) {
				submitBtn.disabled = true;
				submitBtn.textContent = "Resetting...";
			}

			const response = await ResetPassword({
				email: loginEmail,
				otp: otp,
				newPassword: newPassword,
			});

			if (response.status === true) {
				setErrors({});
				// Reset all states and go back to login
				setOtpSent(false);
				setOtpVerified(false);
				setShowPasswordReset(false);
				setOtp("");
				setNewPassword("");
				setConfirmNewPassword("");
				setActiveTab("signin");
			} else {
				setErrors({...newErrors, api: response.message || "Failed to reset password. Please try again."});
			}
		} catch (error) {
			console.error("Password reset error:", error);
			setErrors({api: "Network error. Please try again."});
		} finally {
			// Reset button state
			const submitBtn = document.querySelector(".submit-btn");
			if (submitBtn) {
				submitBtn.disabled = false;
				submitBtn.textContent = "Reset Password";
			}
		}
	};

	const handleResendOTP = async () => {
		try {
			setErrors({});

			// Show loading state
			const resendBtn = document.querySelector(".resend-btn");
			if (resendBtn) {
				resendBtn.textContent = "Sending...";
				resendBtn.disabled = true;
			}

			const response = await ForgotPassword({email: loginEmail});

			if (response.status === true) {
				// Clear Code input for new code
				setOtp("");
			} else {
				setErrors({api: "Failed to resend Code. Please try again."});
			}
		} catch (error) {
			console.error("Resend Code error:", error);
			setErrors({api: "Network error. Please try again."});
		} finally {
			// Reset button state
			const resendBtn = document.querySelector(".resend-btn");
			if (resendBtn) {
				resendBtn.textContent = "Didn't receive code? Resend";
				resendBtn.disabled = false;
			}
		}
	};

	return (
		<>
			<Helmet>
				{activeTab === "signup" ? (
					<>
						<title>Create Your Free Account | JobSiteRating</title>
						<meta name="description" content="Join JobSiteRating to check job-site conditions, share contractor insights, and protect your profit before you bid." />
						<link rel="canonical" href="https://www.jobsiterating.com/signup" />
					</>
				) : (
					<>
						<title>Login | JobSiteRating</title>
						<meta name="description" content="Log in to check job-site conditions and contractor ratings by address." />
						<link rel="canonical" href="https://www.jobsiterating.com/login" />
					</>
				)}
			</Helmet>

			<div className="modern-login-container">
				<div className="row g-0 h-100">
					{/* Left Side - Logo and Form */}
					<div className="col-lg-6 login-form-section">
						<div>
							<div className="login-content">
								{/* Header with Logo and Back Link */}
								<div className="login-header">
									<div className="login-logo-container">
										<a
											href="/"
											className="sidebar-logo"
											onClick={(e) => {
												e.preventDefault();
												navigateToNextWithSync("/");
											}}>
											<img src={`${process.env.PUBLIC_URL}/img/header-logo.png`} alt="JobSiteRating Logo" className="login-main-logo" />
										</a>
									</div>
								</div>

								{/* Form Container */}
								<div className="login-form-container">
									{/* Tab Navigation */}

									{activeTab === "signin" && (
										<div className="tab-content-wrapper">
											<div className="form-section">
												<h2 className="form-title">Sign in</h2>
												<p className="form-subtitle">Please login to continue to your account.</p>

												<form className="login-form">
													<div className="form-group">
														<label htmlFor="email" className="form-label">
															Email
														</label>
														<input type="email" id="email" className="form-input" placeholder="jonas_kahnwald@gmail.com" onChange={(e) => setLoginEmail(e.target.value)} value={loginEmail} />
														{errors.email && <p className="error-text">{errors.email}</p>}
													</div>

													<div className="form-group">
														<label htmlFor="password" className="form-label">
															Password
														</label>
														<div className="password-input-wrapper">
															<input type={showPassword ? "text" : "password"} id="password" className="form-input" placeholder="Password" onChange={(e) => setLoginPassword(e.target.value)} value={loginPassword} />
															<button type="button" className="password-toggle" onClick={() => setShowPassword(!showPassword)}>
																<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																	{showPassword ? (
																		<path
																			d="M17.94 17.94A10.07 10.07 0 0 1 12 20C7 20 2.73 16.39 1 12A18.45 18.45 0 0 1 5.06 5.06M9.9 4.24A9.12 9.12 0 0 1 12 4C17 4 21.27 7.61 23 12A18.5 18.5 0 0 1 19.42 16.42M14.12 14.12A3 3 0 1 1 9.88 9.88M1 1L23 23"
																			stroke="currentColor"
																			strokeWidth="2"
																			strokeLinecap="round"
																			strokeLinejoin="round"
																		/>
																	) : (
																		<path d="M1 12S5 4 12 4S23 12 23 12S19 20 12 20S1 12 1 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																	)}
																	<circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
																</svg>
															</button>
														</div>
														{errors.password && <p className="error-text">{errors.password}</p>}
													</div>

													<div className="form-options">
														<div className="form-check">
															<input type="checkbox" id="remember" className="form-check-input" />
															<label htmlFor="remember" className="form-check-label">
																Keep me logged in
															</label>
														</div>
														<button type="button" className="forgot-password-link" onClick={() => toggleTab("forgot_password")}>
															Forgot password?
														</button>
													</div>
													{errors.api && <p className="api-error-container">{errors.api}</p>}
													<button type="button" className="submit-btn" onClick={handleLogin}>
														Sign in
													</button>
												</form>

												<div className="form-footer">
													<p>
														Need an account?{" "}
														<button className="link-btn" onClick={() => toggleTab("signup")}>
															Create one
														</button>
													</p>
												</div>
											</div>
										</div>
									)}

									{activeTab === "signup" && <SignupComponent toggleTab={toggleTab} />}

									{/* {activeTab === "signup" && (
									<div className="tab-content-wrapper">
										<div className="form-section">
											<h2 className="form-title">Sign up</h2>
											<p className="form-subtitle">Create your account to get started.</p>

											<form className="login-form">
												<div className="form-row">
													<div className="form-group">
														<label htmlFor="firstName" className="form-label">
															First Name
														</label>
														<input
															type="text"
															id="firstName"
															className="form-input"
															placeholder="John"
															value={firstname}
															onChange={(e) => {
																setFirstname(e.target.value);
																if (errors.firstname) {
																	setErrors((prev) => ({...prev, firstname: ""}));
																}
															}}
														/>
														{errors.firstname && <span className="error-text">{errors.firstname}</span>}
													</div>
													<div className="form-group">
														<label htmlFor="lastName" className="form-label">
															Last Name
														</label>
														<input
															type="text"
															id="lastName"
															className="form-input"
															placeholder="Doe"
															value={lastname}
															onChange={(e) => {
																setLastname(e.target.value);
																if (errors.lastname) {
																	setErrors((prev) => ({...prev, lastname: ""}));
																}
															}}
														/>
														{errors.lastname && <span className="error-text">{errors.lastname}</span>}
													</div>
												</div>

												<div className="form-group">
													<label htmlFor="signupEmail" className="form-label">
														Email
													</label>
													<input
														type="email"
														id="signupEmail"
														className="form-input"
														placeholder="john.doe@gmail.com"
														value={email}
														onChange={(e) => {
															setEmail(e.target.value);
															if (errors.email) {
																setErrors((prev) => ({...prev, email: ""}));
															}
														}}
													/>
													{errors.email && <span className="error-text">{errors.email}</span>}
												</div>

												<div className="form-group">
													<label htmlFor="phone" className="form-label">
														Phone Number
													</label>
													<input
														type="tel"
														id="phone"
														className="form-input"
														placeholder="+1 (555) 123-4567"
														value={phone}
														onChange={(e) => {
															setPhone(e.target.value);
															if (errors.phone) {
																setErrors((prev) => ({...prev, phone: ""}));
															}
														}}
													/>
													{errors.phone && <span className="error-text">{errors.phone}</span>}
												</div>

												{userType === "contractor" && (
													<>
														<div className="form-group">
															<label htmlFor="businessName" className="form-label">
																Business Name
															</label>
															<input
																type="text"
																id="businessName"
																className="form-input"
																placeholder="ABC Construction Company"
																value={businessName}
																onChange={(e) => {
																	setBusinessName(e.target.value);

																	if (errors.businessName) {
																		setErrors((prev) => ({...prev, businessName: ""}));
																	}
																}}
															/>
															{errors.businessName && <span className="error-text">{errors.businessName}</span>}
														</div>
													</>
												)}

												{userType === "contractor" && (
													<>
														<div className="form-group">
															<label htmlFor="address" className="form-label">
																Business Address
															</label>
															<GoogleAddress
																styleFlag="loginStyle"
																address={addressString}
																callBackAction={(val) => {
																	setAddressString(val.value);
																	if (errors.address) {
																		setErrors((prev) => ({...prev, address: ""}));
																	}
																}}
															/>

															{errors.addressString && <span className="error-text">{errors.addressString}</span>}
														</div>
													</>
												)}

												<div className="form-group">
													<label htmlFor="profileImage" className="form-label">
														Profile Image (Optional)
													</label>
													<div className="profile-image-upload">
														<input
															type="file"
															id="profileImage"
															accept="image/*"
															className="form-input"
															style={{display: "none"}}
															onChange={(e) => {
																const file = e.target.files[0];
																if (file) {
																	if (file.size > 5 * 1024 * 1024) {
																		setErrors((prev) => ({...prev, profileImage: "Image size should be less than 5MB"}));
																		return;
																	}
																	setProfileImage(file);
																	const reader = new FileReader();
																	reader.onloadend = () => {
																		setProfileImagePreview(reader.result);
																	};
																	reader.readAsDataURL(file);
																	if (errors.profileImage) {
																		setErrors((prev) => ({...prev, profileImage: ""}));
																	}
																}
															}}
														/>
														<div className="d-flex gap-3 align-items-center">
															{profileImagePreview && (
																<div className="profile-image-preview">
																	<img src={profileImagePreview} alt="Profile preview" style={{width: "100px", height: "100px", borderRadius: "50%", objectFit: "cover"}} />
																</div>
															)}
															{profileImagePreview && (
																<button
																	type="button"
																	onClick={() => {
																		setProfileImage(null);
																		setProfileImagePreview(null);
																		document.getElementById("profileImage").value = "";
																	}}
																	className="btn btn-sm btn-danger">
																	Remove
																</button>
															)}
															<label htmlFor="profileImage" className="btn btn-primary btn-sm" style={{cursor: "pointer", margin: 0}}>
																Choose Image
															</label>
														</div>
														{errors.profileImage && <span className="error-text">{errors.profileImage}</span>}
													</div>
												</div>

												{userType === "client" && (
													<div className="form-group">
														<label htmlFor="address" className="form-label">
															Address
														</label>
														<input
															type="text"
															id="address"
															className="form-input"
															placeholder="123 Main Street, City, State 12345"
															value={address}
															onChange={(e) => {
																setAddress(e.target.value);
																if (errors.address) {
																	setErrors((prev) => ({...prev, address: ""}));
																}
															}}
														/>
														{errors.address && <span className="error-text">{errors.address}</span>}
													</div>
												)}

												<div className="form-group">
													<label htmlFor="signupPassword" className="form-label">
														Password
													</label>
													<div className="password-input-wrapper">
														<input
															type={showPassword ? "text" : "password"}
															id="signupPassword"
															className="form-input"
															placeholder="Create a strong password"
															value={password}
															onChange={(e) => {
																setPassword(e.target.value);
																if (errors.password) {
																	setErrors((prev) => ({...prev, password: ""}));
																}
															}}
														/>
														{errors.password && <span className="error-text">{errors.password}</span>}
														<button
															type="button"
															className="password-toggle"
															onClick={() => {
																setShowPassword(!showPassword);
															}}>
															<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																{showPassword ? (
																	<path
																		d="M17.94 17.94A10.07 10.07 0 0 1 12 20C7 20 2.73 16.39 1 12A18.45 18.45 0 0 1 5.06 5.06M9.9 4.24A9.12 9.12 0 0 1 12 4C17 4 21.27 7.61 23 12A18.5 18.5 0 0 1 19.42 16.42M14.12 14.12A3 3 0 1 1 9.88 9.88M1 1L23 23"
																		stroke="currentColor"
																		strokeWidth="2"
																		strokeLinecap="round"
																		strokeLinejoin="round"
																	/>
																) : (
																	<path d="M1 12S5 4 12 4S23 12 23 12S19 20 12 20S1 12 1 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																)}
																<circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
															</svg>
														</button>
													</div>
												</div>

												<div className="form-group">
													<label htmlFor="confirmPassword" className="form-label">
														Confirm Password
													</label>
													<input
														type="password"
														id="confirmPassword"
														className="form-input"
														placeholder="Confirm your password"
														value={confirmPassword}
														onChange={(e) => {
															setConfirmPassword(e.target.value);
															if (errors.confirmPassword) {
																setErrors((prev) => ({...prev, confirmPassword: ""}));
															}
														}}
													/>
													{errors.confirmPassword && <span className="error-text">{errors.confirmPassword}</span>}
												</div>

												<div className="form-options align-items-start flex-column">
													<div className="form-check">
														<input
															type="checkbox"
															id="terms"
															className="form-check-input"
															checked={termsAccepted}
															onChange={(e) => {
																setTermsAccepted(e.target.checked);
																if (errors.terms) {
																	setErrors((prev) => ({...prev, terms: ""}));
																}
															}}
														/>
														<label htmlFor="terms" className="form-check-label">
															I agree to the{" "}
															<Link to="/terms-of-service" className="link">
																Terms of Service
															</Link>{" "}
															and{" "}
															<Link to="/privacy-policy" className="link">
																Privacy Policy
															</Link>
														</label>
													</div>
													{errors.terms && <span className="error-text">{errors.terms}</span>}
												</div>
												{apiError && <p className="api-error-container">{apiError}</p>}
												<button
													type="button"
													className="submit-btn"
													onClick={(e) => {
														e.preventDefault();
														handleSignup();
													}}>
													Create Account
												</button>
											</form>
											<div className="form-footer">
												<p>
													Already have an account?{" "}
													<button className="link-btn" onClick={() => toggleTab("signin")}>
														Sign in
													</button>
												</p>
											</div>
										</div>
									</div>
								)} */}

									{activeTab === "forgot_password" && (
										<div className="tab-content-wrapper">
											<div className="form-section">
												{!otpSent ? (
													// Step 1: Email Input
													<form className="login-form">
														<h2 className="form-title">Forgot Password</h2>
														<p className="form-subtitle">Please enter the e-mail address for your account. A verification code will be sent to you.</p>
														<div className="form-group">
															<label htmlFor="email" className="form-label">
																Email
															</label>
															<input type="email" id="email" className="form-input" placeholder="jonas_kahnwald@gmail.com" onChange={(e) => setLoginEmail(e.target.value)} value={loginEmail} />
															{errors.email && <p className="error-text">{errors.email}</p>}
														</div>
														{errors.api && <p className="api-error-container">{errors.api}</p>}
														<button type="button" className="submit-btn" onClick={handleForgotPassword}>
															Send Code
														</button>
													</form>
												) : !otpVerified ? (
													// Step 2: Code Verification
													<div className="otp-verification-section">
														<div className="otp-header">
															<div className="otp-icon">
																<svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																	<path d="M22 2H2V22H22V2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																	<path d="M22 12H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																	<path d="M6 12H2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																	<path d="M12 6V2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																	<path d="M12 22V18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																</svg>
															</div>
															<h3 className="otp-title">Enter Verification Code</h3>
															<p className="otp-subtitle">
																We've sent a 6-digit code to <strong>{loginEmail}</strong>
															</p>
														</div>

														<form className="otp-form">
															<div className="form-group">
																<label htmlFor="otp" className="form-label">
																	Verification Code
																</label>
																<input
																	type="text"
																	id="otp"
																	className="form-input otp-input"
																	placeholder="123456"
																	maxLength="6"
																	onChange={(e) => {
																		const value = e.target.value.replace(/\D/g, "");
																		setOtp(value);
																		if (errors.otp) {
																			setErrors((prev) => ({...prev, otp: ""}));
																		}
																	}}
																	value={otp}
																/>
																{errors.otp && <p className="error-text">{errors.otp}</p>}
															</div>

															{errors.api && <p className="api-error-container">{errors.api}</p>}

															<button type="button" className="submit-btn" onClick={handleVerifyOTP}>
																Verify Code
															</button>

															<div className="otp-actions">
																<button type="button" className="resend-btn" onClick={handleResendOTP}>
																	Didn't receive code? Resend
																</button>
																<button
																	type="button"
																	className="back-btn"
																	onClick={() => {
																		setOtpSent(false);
																		setOtp("");
																		setErrors({});
																	}}>
																	Back to Email
																</button>
															</div>
														</form>
													</div>
												) : (
													// Step 3: Password Reset
													<div className="password-reset-section">
														<div className="reset-header">
															<div className="reset-icon">
																<svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																	<path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																	<path
																		d="M12 18C13.1 18 14 18.9 14 20C14 21.1 13.1 22 12 22C10.9 22 10 21.1 10 20C10 18.9 10.9 18 12 18Z"
																		stroke="currentColor"
																		strokeWidth="2"
																		strokeLinecap="round"
																		strokeLinejoin="round"
																	/>
																	<path
																		d="M12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14C10.9 14 10 13.1 10 12C10 10.9 10.9 10 12 10Z"
																		stroke="currentColor"
																		strokeWidth="2"
																		strokeLinecap="round"
																		strokeLinejoin="round"
																	/>
																</svg>
															</div>
															<h3 className="reset-title">Create New Password</h3>
															<p className="reset-subtitle">Your Code has been verified. Please create a new password.</p>
														</div>

														<form className="reset-form">
															<div className="form-group">
																<label htmlFor="newPassword" className="form-label">
																	New Password
																</label>
																<input
																	type="password"
																	id="newPassword"
																	className="form-input"
																	placeholder="Enter new password"
																	onChange={(e) => {
																		setNewPassword(e.target.value);
																		if (errors.newPassword) {
																			setErrors((prev) => ({...prev, newPassword: ""}));
																		}
																	}}
																	value={newPassword}
																/>
																{errors.newPassword && <p className="error-text">{errors.newPassword}</p>}
															</div>

															<div className="form-group">
																<label htmlFor="confirmNewPassword" className="form-label">
																	Confirm New Password
																</label>
																<input
																	type="password"
																	id="confirmNewPassword"
																	className="form-input"
																	placeholder="Confirm new password"
																	onChange={(e) => {
																		setConfirmNewPassword(e.target.value);
																		if (errors.confirmNewPassword) {
																			setErrors((prev) => ({...prev, confirmNewPassword: ""}));
																		}
																	}}
																	value={confirmNewPassword}
																/>
																{errors.confirmNewPassword && <p className="error-text">{errors.confirmNewPassword}</p>}
															</div>

															{errors.api && <p className="api-error-container">{errors.api}</p>}

															<button type="button" className="submit-btn" onClick={handleResetPassword}>
																Reset Password
															</button>

															<div className="reset-actions">
																<button
																	type="button"
																	className="back-btn"
																	onClick={() => {
																		setOtpVerified(false);
																		setOtp("");
																		setErrors({});
																	}}>
																	Back to Code
																</button>
															</div>
														</form>
													</div>
												)}
											</div>
										</div>
									)}
								</div>
							</div>
						</div>
					</div>

					{/* Right Side - Image */}
					<div className="col-lg-6 login-image-section">
						<div className="image-container">
							<img src={`${process.env.PUBLIC_URL}/img/login2.png`} alt="Industrial Construction Site" className="login-background-image" />
						</div>
					</div>
				</div>

				{/* <DialogBox
				open={isOpen}
				handleClose={() => {
					setIsOpen(false);
				}}
				onSkip={() => {
					setIsOpen(false);
					setActiveTab("signin");
				}}
				addressString={addressString}
			/> */}
			</div>
		</>
	);
};

export default LoginPage;

const SignupComponent = ({toggleTab}) => {
	const [screen, setScreen] = useState("Signup");
	const [history, setHistory] = useState([]);

	const [uuid, setUuid] = useState(null);
	const [userDetails, setUserDetails] = useState({});
	const [tabValue, setTabValue] = useState(() => {
		try {
			const saved = localStorage.getItem("signup_form_data");
			return saved ? JSON.parse(saved).tabValue || "one" : "one";
		} catch {
			return "one";
		}
	});

	const [error, setError] = useState(null);
	const [emailTest, setEmailTest] = useState(null);
	const [success, setSuccess] = useState(null);
	const [isLoader, setIsLoader] = useState(false);

	const [isEmail, setIsEmail] = useState(null);
	const [isPhone, setIsPhone] = useState(null);
	const [isGoogleListing, setIsGoogleListing] = useState(null);
	const [isBusinessWebsite, setIsBusinessWebsite] = useState(null);

	const [profileImage, setProfileImage] = useState(null);
	const [profileImagePreview, setProfileImagePreview] = useState(null);

	const [singUpLoader, setSingUpLoader] = useState(false);

	const [showPassword, setShowPassword] = useState(false);

	// Form data persistence
	const [savedFormData, setSavedFormData] = useState(() => {
		try {
			const saved = localStorage.getItem("signup_form_data");
			return saved ? JSON.parse(saved) : null;
		} catch {
			return null;
		}
	});

	// Save form data to localStorage
	const saveFormData = (formValues) => {
		try {
			const dataToSave = {
				...formValues,
				profileImagePreview: profileImagePreview,
				tabValue: tabValue,
			};
			localStorage.setItem("signup_form_data", JSON.stringify(dataToSave));
			setSavedFormData(dataToSave);
		} catch (error) {
			console.error("Error saving form data:", error);
		}
	};

	// Clear saved form data
	const clearSavedFormData = () => {
		try {
			localStorage.removeItem("signup_form_data");
			setSavedFormData(null);
		} catch (error) {
			console.error("Error clearing form data:", error);
		}
	};

	// const handleResendOTP = async () => {
	// 	try {
	// 		setSuccess(null);
	// 		setError(null);
	// 		const response = await ForgotPassword({email: loginEmail});

	// 		if (response.status === true) {
	// 			setSuccess("Verification code resent successfully to your email.");
	// 			setError(null);
	// 			// setOtp("");
	// 		} else {
	// 			setError("Failed to resend Code. Please try again.");
	// 		}
	// 	} catch (error) {
	// 		console.error("Resend Code error:", error);
	// 		setError("Network error. Please try again.");
	// 	}
	// };

	// const handleOptVerify = async (values) => {
	// 	try {
	// 		const response = await VerifyMailAndBusinessVerifyService({
	// 			uuid,
	// 			otp: values.otp,
	// 		});

	// 		if (response.status === true) {
	// 			setScreen(3);

	// 			setSuccess(response?.message);
	// 			setError(null);

	// 			const RoleString = response.data.role === "super-admin" ? super_admin_role_id : response.data.role === "admin" ? admin_role_id : contractor_role_id;

	// 			localStorage.setItem("auth_token", response.data.token);
	// 			localStorage.setItem("is_login", true);
	// 			localStorage.setItem("first_name", response.data.first_name);
	// 			localStorage.setItem("last_name", response.data.last_name);
	// 			localStorage.setItem("profile_image", response.data.profile_image);
	// 			localStorage.setItem("role", RoleString);
	// 			localStorage.setItem("verified", response.data.verified);
	// 			localStorage.setItem("badge", response.data.badge || false);

	// 			if (response.data.isEmailMatching) {
	// 				setScreen(4);
	// 			} else {
	// 				setScreen(3);
	// 			}
	// 		}
	// 		if (response.status !== true) {
	// 			setSuccess(null);
	// 			setError(response?.message);
	// 		}
	// 	} catch (err) {
	// 		// setError(err?.message);
	// 	}
	// };

	// const closeOtpModal = () => {
	// 	setOtpModal({
	// 		open: false,
	// 		target: null,
	// 		value: "",
	// 		otp: "",
	// 		sending: false,
	// 		verifying: false,
	// 		error: null,
	// 		success: null,
	// 	});
	// };

	// const handleSendOtp = async (target, value) => {
	// 	const apiFn = target === "email" ? SendEmailChangeOtp : SendPhoneChangeOtp;
	// 	const payload = target === "email" ? {new_email: value} : {new_phone: value};

	// 	const response = await apiFn(payload);

	// 	if (response?.status) {
	// 		if (!value) {
	// 			setOtpModal((prev) => ({
	// 				...prev,
	// 				open: true,
	// 				target,
	// 				value,
	// 				error: `Please enter a ${target === "email" ? "new email" : "new phone number"} first.`,
	// 				success: null,
	// 			}));
	// 			return;
	// 		}

	// 		setOtpModal((prev) => ({
	// 			...prev,
	// 			open: true,
	// 			target,
	// 			value,
	// 			otp: "",
	// 			sending: true,
	// 			verifying: false,
	// 			error: null,
	// 			success: null,
	// 		}));

	// 		setOtpModal((prev) => ({
	// 			...prev,
	// 			sending: false,
	// 			success: "Code sent successfully. Please check your email.",
	// 			error: null,
	// 		}));
	// 	} else {
	// 		setOtpModal((prev) => ({
	// 			...prev,
	// 			sending: false,
	// 			error: response?.message || "Failed to send Code. Please try again.",
	// 			success: null,
	// 		}));
	// 	}
	// };

	// const handleVerifyOtpModal = async () => {
	// 	if (!otpModal.otp) {
	// 		setOtpModal((prev) => ({...prev, error: "Please enter the Code sent to your email."}));
	// 		return;
	// 	}

	// 	setOtpModal((prev) => ({...prev, verifying: true, error: null, success: null}));
	// 	const isEmail = otpModal.target === "email";
	// 	const apiFn = isEmail ? VerifyEmailChangeOtp : VerifyPhoneChangeOtp;
	// 	const payload = isEmail ? {new_email: otpModal.value, otp: otpModal.otp} : {new_phone: otpModal.value, otp: otpModal.otp};

	// 	const response = await apiFn(payload);

	// 	if (response?.status) {
	// 		if (isEmail) {
	// 			setUserDetails((prev) => ({...prev, businessEmail: otpModal.value}));
	// 			formikRef.current?.setFieldValue("businessEmail", otpModal.value);
	// 			formikRef.current?.setFieldValue("isEmailEditing", false);
	// 		} else {
	// 			setUserDetails((prev) => ({...prev, businessPhone: otpModal.value}));
	// 			formikRef.current?.setFieldValue("businessPhone", otpModal.value);
	// 			formikRef.current?.setFieldValue("isPhoneEditing", false);
	// 		}
	// 		closeOtpModal();
	// 	} else {
	// 		setOtpModal((prev) => ({
	// 			...prev,
	// 			verifying: false,
	// 			error: response?.message || "Code verification failed. Please try again.",
	// 		}));
	// 	}
	// };

	// const handleBusinessVerify = async (values) => {
	// 	try {
	// 		setVerifyLoading(true);
	// 		setVerifySuccess(null);
	// 		setVerifyError(null);

	// 		const payload = {
	// 			uuid,
	// 			businessName: values?.businessName,
	// 			businessWebsite: values?.businessWebsite,
	// 			businessAddress: values?.businessAddress,
	// 			googleListing: values?.googleListing,
	// 		};

	// 		const response = await BusinessVerifyService(payload);

	// 		if (response?.status) {
	// 			setVerifySuccess(response?.message || "Business verified successfully.");
	// 			setVerifyError(null);
	// 			setVerifyMessage(response?.message || "Business verified successfully.");
	// 			setScreen(4);
	// 		} else {
	// 			setVerifyError(response?.message || "Verification failed. Please check your details.");
	// 			setVerifySuccess(null);
	// 		}
	// 	} catch (err) {
	// 		setVerifyError("Something went wrong. Please try again.");
	// 		setVerifySuccess(null);
	// 	} finally {
	// 		setVerifyLoading(false);
	// 	}
	// };

	const normalizePhoneInput = (val) => {
		if (val === undefined || val === null) return "+1";
		const digits = val.toString().replace(/[^\d]/g, "");
		// always ensure it starts with country code 1
		const rest = digits.startsWith("1") ? digits.slice(1) : digits;
		return "+1" + rest;
	};

	const handleChange = (event, newValue) => {
		setTabValue(newValue);
		// Save tab value to localStorage
		if (savedFormData) {
			saveFormData({...savedFormData, tabValue: newValue});
		}
	};

	// Initialize history on mount
	useEffect(() => {
		if (history.length === 0) {
			const initialHistory = ["Signup"];
			setHistory(initialHistory);
			// Initialize browser history
			window.history.replaceState({screen: "Signup", history: initialHistory}, "", window.location.href);
		}
	}, []);

	// Update history when screen changes
	useEffect(() => {
		if (history.length > 0 && history[history.length - 1] !== screen) {
			const newHistory = [...history, screen];
			setHistory(newHistory);
			// Push to browser history
			window.history.pushState({screen, history: newHistory}, "", window.location.href);
		}
	}, [screen]);

	// Handle browser back/forward buttons
	useEffect(() => {
		const handlePopState = (event) => {
			if (event.state && event.state.history && event.state.history.length > 0) {
				const newHistory = event.state.history;
				const lastScreen = newHistory[newHistory.length - 1];
				setHistory(newHistory);
				setScreen(lastScreen);
			} else if (history.length > 1) {
				// Fallback: use our internal history
				const newHistory = [...history];
				newHistory.pop();
				const lastScreen = newHistory[newHistory.length - 1];
				setHistory(newHistory);
				setScreen(lastScreen);
			}
		};

		window.addEventListener("popstate", handlePopState);
		return () => {
			window.removeEventListener("popstate", handlePopState);
		};
	}, []);

	const handleBack = () => {
		if (history.length <= 1) {
			// If at first screen, go back to signin
			toggleTab("signin");
			return;
		}
		const newHistory = [...history];
		newHistory.pop(); // remove current screen
		const lastScreen = newHistory[newHistory.length - 1];
		setHistory(newHistory);
		setScreen(lastScreen);
		// Update browser history to match
		window.history.pushState({screen: lastScreen, history: newHistory}, "", window.location.href);
	};

	const handleSignup = async (values) => {
		try {
			setSingUpLoader(true);
			setError(null);
			setSuccess(null);
			setIsLoader(true);

			// Save form data before submission
			saveFormData(values);

			const formData = new FormData();

			formData.append("first_name", values?.first_name);
			formData.append("last_name", values?.last_name);
			formData.append("business_name", values?.businessName);
			formData.append("business_website", values?.businessWebsite);
			formData.append("phone", values?.businessPhone);
			formData.append("email", values?.businessEmail);
			formData.append("address", values?.businessAddress);
			formData.append("business_url", values?.googleListing);
			formData.append("password", values?.confirmPassword);

			setIsEmail(values?.businessEmail);
			setIsPhone(values?.businessPhone);
			setIsBusinessWebsite(values?.businessWebsite);
			setIsGoogleListing(values?.googleListing);

			if (profileImage) {
				formData.append("profile_image", profileImage);
			}

			const response = await PendingUpdateSignupService(formData);
			setIsLoader(false);
			setSingUpLoader(false);

			if (response.status === true) {
				setEmailTest(response?.data?.message);
				setUuid(response.data?.user_uuid);
				setScreen(response?.data?.action);
				setUserDetails(response?.data);

				const RoleString = response.data.role === "super-admin" ? super_admin_role_id : response.data.role === "admin" ? admin_role_id : contractor_role_id;

				localStorage.setItem("auth_token", response.data.token);
				localStorage.setItem("is_login", false);
				localStorage.setItem("first_name", response.data.first_name);
				localStorage.setItem("last_name", response.data.last_name);
				localStorage.setItem("profile_image", response.data.profile_image);
				localStorage.setItem("role", RoleString);
				localStorage.setItem("verified", response.data.verified);
				localStorage.setItem("trusted", response.data.trusted);
				localStorage.setItem("badge", response.data.badge || false);

				const message = "You have been successfully registered.";
				setSuccess(response.message);
				// sweetAlerts("success", message);
			}
			if (response.status !== true) {
				sweetAlerts("error", response.message);
				setError(response.message);
			}
		} catch (err) {}
	};

	const handleBusinessVerificationCheck = async (values) => {
		try {
			setError(null);
			setSuccess(null);
			setIsLoader(true);

			// Save verification form data
			if (savedFormData) {
				saveFormData({...savedFormData, ...values});
			}

			const response = await PendingBusinessVerificationPromptService({
				uuid,
				...values,
			});
			setIsLoader(false);

			setIsPhone(values.phone);
			setIsEmail(values.email);
			setIsBusinessWebsite(values?.businessWebsite);
			setIsGoogleListing(values?.googleListing);

			if (response.status === true) {
				setScreen(response?.data?.action);
				setEmailTest(response?.data?.message);
				const message = "You have been successfully registered.";
				setSuccess(response.message);
				// sweetAlerts("success", message);
			}
			if (response.status !== true) {
				// sweetAlerts("error", response.message);
				setError(response.message);
			}
		} catch (err) {
			console.log("err", err);
		}
	};

	const sendOptEmail = async () => {
		try {
			setError(null);
			setSuccess(null);
			setIsLoader(true);

			const response = await PendingSendEmailChangeOtpService({
				new_email: isEmail,
			});

			setIsLoader(false);

			if (response.status === true) {
				setScreen("EmailOtp");

				const message = "Please check your email for verification code.";
				setSuccess(message);
			}
			if (response.status !== true) {
				setError(response.message);
			}
		} catch (err) {
			console.log("err", err);
		}
	};

	const sendOptPhone = async () => {
		try {
			setError(null);
			setSuccess(null);
			setIsLoader(true);

			const response = await PendingSendPhoneChangeOtpService({
				new_phone: isPhone,
			});

			setIsLoader(false);

			if (response.status === true) {
				setScreen(response?.data?.action);

				const message = "You have been successfully registered.";
				setSuccess(response.message);
			}
			if (response.status !== true) {
				setError(response.message);
			}
		} catch (err) {
			console.log("err", err);
		}
	};

	const verifyOptEmail = async (values) => {
		try {
			setError(null);
			setSuccess(null);
			setIsLoader(true);

			const response = await PendingVerifyEmailChangeOtpService({
				new_email: isEmail,
				googleListing: isGoogleListing,
				businessWebsite: isBusinessWebsite || "",
				...values,
			});

			setIsLoader(false);

			if (response.status === true) {
				const RoleString = response.data.role === "super-admin" ? super_admin_role_id : response.data.role === "admin" ? admin_role_id : contractor_role_id;

				localStorage.setItem("auth_token", response.data.token);
				localStorage.setItem("is_login", true);
				localStorage.setItem("first_name", response.data.first_name);
				localStorage.setItem("last_name", response.data.last_name);
				localStorage.setItem("profile_image", response.data.profile_image);
				localStorage.setItem("role", RoleString);
				localStorage.setItem("verified", response.data.verified);
				localStorage.setItem("trusted", response.data.trusted);
				localStorage.setItem("badge", response.data.badge || false);

				if (response.data?.action === "OTPVerifiedSuccessfully") {
					// Clear saved form data on successful completion
					clearSavedFormData();
					setTimeout(() => {
						window.location.href = "/contractor-dashboard";
					}, 1000); // 1 second
				}

				setScreen(response.data?.action);

				const message = response.message;
				setSuccess(response.message);
			}
			if (response.status !== true) {
				setError(response.message);
			}
		} catch (err) {
			console.log("err", err);
		}
	};

	const verifyOptPhone = async (values) => {
		try {
			setError(null);
			setSuccess(null);
			setIsLoader(true);

			const response = await PendingVerifyPhoneChangeOtpService({
				new_phone: isPhone,
				googleListing: isGoogleListing,
				otp: values.otp,
			});

			setIsLoader(false);

			if (response.status === true) {
				setScreen(response?.data?.action);

				delete values.otp;

				// localStorage.setItem("verified", true);
				// localStorage.setItem("trusted", true);
				setSuccess(response.message);
			}
			if (response.status !== true) {
				setError(response.message);
			}
		} catch (err) {
			console.log("err", err);
		}
	};

	useEffect(() => {
		if (screen === "BusinessVerifiedSuccessfully") {
			localStorage.setItem("verified", true);
			// Clear saved form data on successful verification
			clearSavedFormData();
		}
	}, [screen]);

	// Restore profile image preview on mount
	useEffect(() => {
		if (savedFormData?.profileImagePreview) {
			setProfileImagePreview(savedFormData.profileImagePreview);
		}
	}, []);

	// Back button component
	const BackButton = () => {
		if (history.length <= 1) return null;
		return (
			<button
				type="button"
				onClick={handleBack}
				className="back-button"
				style={{
					background: "none",
					border: "none",
					cursor: "pointer",
					display: "flex",
					alignItems: "center",
					gap: "8px",
					marginBottom: "20px",
					color: "#666",
					fontSize: "14px",
					padding: "8px 0",
				}}>
				<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
				</svg>
				Back
			</button>
		);
	};

	return (
		<div>
			{screen === "Signup" && (
				<div className="tab-content-wrapper">
					<div className="form-section">
						<BackButton />
						<h2 className="form-title">Sign up</h2>
						<p className="form-subtitle">Enter your business information (same as your website/Google Business Listing/State registration)</p>

						{success && (
							<Alert severity="success" sx={{my: 2}}>
								{success}
							</Alert>
						)}
						{error && (
							<Alert severity="error" sx={{my: 2}}>
								{error}
							</Alert>
						)}
						<Formik
							enableReinitialize
							initialValues={{
								first_name: savedFormData?.first_name || "",
								last_name: savedFormData?.last_name || "",
								businessName: savedFormData?.businessName || "",
								businessWebsite: savedFormData?.businessWebsite || "",
								businessPhone: savedFormData?.businessPhone || normalizePhoneInput(userDetails.phone) || "+1",
								businessEmail: savedFormData?.businessEmail || "",
								businessAddress: savedFormData?.businessAddress || "",
								googleListing: savedFormData?.googleListing || "",
								password: savedFormData?.password || "",
								confirmPassword: savedFormData?.confirmPassword || "",
								termsAccepted: savedFormData?.termsAccepted || false,
							}}
							validationSchema={Yup.object({
								first_name: Yup.string().min(2, "Minimum 2 characters").required("First name is required"),
								last_name: Yup.string().min(2, "Minimum 2 characters").required("Last name is required"),
								businessName: Yup.string().min(2, "Business name is required").required("Business name is required"),
								businessWebsite: Yup.string()
									.nullable()
									.test("valid-business-website", "Enter a valid business website (e.g. xyz.com)", (value) => {
										if (!value) return true; // Allow null / empty
										const pattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/;
										return pattern.test(value);
									}),
								businessPhone: Yup.string()
									.transform((value) => {
										if (!value || value.trim() === "" || value.trim() === "+1") {
											return null;
										}
										return value;
									})
									.nullable()
									.matches(/^\+\d{6,15}$/, "Enter valid phone number with country code (e.g. +14155550123)"),
								businessEmail: Yup.string().email("Enter valid email").required("Business email is required"),
								businessAddress: Yup.string().nullable(),
								googleListing: Yup.string().url("Enter valid Google business link").nullable(),
								password: Yup.string().min(8, "Minimum 8 characters").matches(/[A-Z]/, "Must include one uppercase letter").matches(/[0-9]/, "Must include one number").required("Password is required"),
								confirmPassword: Yup.string()
									.oneOf([Yup.ref("password")], "Passwords must match")
									.required("Confirm password is required"),
								termsAccepted: Yup.boolean().oneOf([true], "You must accept Terms & Privacy Policy"),
							})}
							onSubmit={handleSignup}>
							{(props) => {
								const {setFieldValue, handleSubmit, resetForm, dirty, values, errors} = props;
								return (
									<Form noValidate>
										<div className="form-row">
											<div className="form-group">
												<label htmlFor="first_name" className="form-label">
													First Name * <span style={{fontWeight: 100, color: "#8e8e8eff", fontSize: 12}}>(Owner/Manager)</span>
												</label>
												<input
													type="text"
													id="first_name"
													className="form-input"
													placeholder="Enter your first name"
													value={values.first_name}
													onChange={(e) => {
														setFieldValue("first_name", e.target.value);
													}}
												/>
												{errors.first_name && <span className="error-text">{errors.first_name}</span>}
											</div>
											<div className="form-group">
												<label htmlFor="last_name" className="form-label">
													Last Name *
												</label>
												<input
													type="text"
													id="last_name"
													className="form-input"
													placeholder="Enter your last name"
													value={values.last_name}
													onChange={(e) => {
														setFieldValue("last_name", e.target.value);
													}}
												/>
												{errors.last_name && <span className="error-text">{errors.last_name}</span>}
											</div>
										</div>

										<div className="form-group">
											<label htmlFor="businessName" className="form-label">
												Business Name *
											</label>
											<input
												type="text"
												id="businessName"
												className="form-input"
												placeholder="Enter your Business Name"
												value={values.businessName}
												onChange={(e) => {
													setFieldValue("businessName", e.target.value);
												}}
											/>
											{errors.businessName && <span className="error-text">{errors.businessName}</span>}
										</div>

										<div className="form-group">
											<label htmlFor="businessWebsite" className="form-label">
												Business Website
											</label>
											<input
												type="text"
												id="businessWebsite"
												className="form-input"
												placeholder="Enter your Business Website"
												value={values.businessWebsite}
												onChange={(e) => {
													setFieldValue("businessWebsite", e.target.value);
												}}
											/>
											{errors.businessWebsite && <span className="error-text">{errors.businessWebsite}</span>}
										</div>

										<div className="form-group">
											<label htmlFor="businessPhone" className="form-label">
												Business Phone Number <span style={{fontWeight: 100, color: "#8e8e8eff", fontSize: 12}}>(cell/land as listed on your website)</span>
											</label>

											<input
												type="text"
												id="businessPhone"
												className="form-input"
												placeholder="Enter your Business Phone  Ex. +1 (555) 123-4567"
												value={values.businessPhone}
												onChange={(e) => {
													setFieldValue("businessPhone", normalizePhoneInput(e.target.value));
												}}
											/>
											{errors.businessPhone && <span className="error-text">{errors.businessPhone}</span>}
										</div>

										<div className="form-group">
											<label htmlFor="businessPhone" className="form-label">
												Business Email * <br />
												<span style={{fontWeight: 100, color: "#8e8e8eff", fontSize: 12}}>
													(Preferred email: matches your website domain. E.g., your website is mybusiness.com, your email is abc@mybusiness.com)
												</span>{" "}
											</label>
											<input
												type="text"
												id="businessEmail"
												className="form-input"
												placeholder="Enter your Business Email"
												value={values.businessEmail}
												onChange={(e) => {
													setFieldValue("businessEmail", e.target.value);
												}}
											/>
											{errors.businessEmail && <span className="error-text">{errors.businessEmail}</span>}
										</div>

										<div className="form-group">
											<label htmlFor="address" className="form-label">
												Business Address <span style={{fontWeight: 100, color: "#8e8e8eff", fontSize: 12}}>(If applicable)</span>{" "}
											</label>
											<GoogleAddress
												styleFlag="loginStyle"
												address={values?.businessAddress}
												callBackAction={(val) => {
													setFieldValue("businessAddress", val.value);
												}}
											/>
											{errors.businessAddress && <span className="error-text">{errors.businessAddress}</span>}
										</div>

										<div className="form-group">
											<label htmlFor="googleListing" className="form-label">
												Google Business Listing <br />
												<span style={{fontWeight: 100, color: "#8e8e8eff", fontSize: 12}}>
													(Copy and paste your Google Business Listing link here. If your business is not listed in Google, we recommend listing it)
												</span>
											</label>

											<input
												type="text"
												id="googleListing"
												className="form-input"
												placeholder="Enter Your Google Business Listing"
												value={values.googleListing}
												onChange={(e) => {
													setFieldValue("googleListing", e.target.value);
												}}
											/>
											{errors.googleListing && <span className="error-text">{errors.googleListing}</span>}
										</div>

										<div className="form-group">
											<label htmlFor="profileImage" className="form-label">
												Profile Image <span style={{fontWeight: 100, color: "#8e8e8eff", fontSize: 12}}>(Optional)</span>
											</label>
											<div className="profile-image-upload">
												<input
													type="file"
													id="profileImage"
													accept="image/*"
													className="form-input"
													style={{display: "none"}}
													onChange={(e) => {
														const file = e.target.files[0];
														if (file) {
															if (file.size > 5 * 1024 * 1024) {
																// setErrors((prev) => ({...prev, profileImage: "Image size should be less than 5MB"}));
																return;
															}
															setProfileImage(file);
															const reader = new FileReader();
															reader.onloadend = () => {
																setProfileImagePreview(reader.result);
															};
															reader.readAsDataURL(file);
															if (errors.profileImage) {
																// setErrors((prev) => ({...prev, profileImage: ""}));
															}
														}
													}}
												/>
												<div className="d-flex gap-3 align-items-center">
													{profileImagePreview && (
														<div className="profile-image-preview">
															<img src={profileImagePreview} alt="Profile preview" style={{width: "100px", height: "100px", borderRadius: "50%", objectFit: "cover"}} />
														</div>
													)}
													{profileImagePreview && (
														<button
															type="button"
															onClick={() => {
																setProfileImage(null);
																setProfileImagePreview(null);
																document.getElementById("profileImage").value = "";
															}}
															className="btn btn-sm btn-danger">
															Remove
														</button>
													)}
													<label htmlFor="profileImage" className="btn btn-primary btn-sm" style={{cursor: "pointer", margin: 0}}>
														Choose Image
													</label>
												</div>
												{errors?.profileImage && <span className="error-text">{errors?.profileImage}</span>}
											</div>
										</div>

										<div className="form-group">
											<label htmlFor="password" className="form-label">
												Password *
											</label>
											<div className="password-input-wrapper">
												<input
													type={showPassword ? "text" : "password"}
													id="password"
													className="form-input"
													value={values.password}
													onChange={(e) => {
														setFieldValue("password", e.target.value);
													}}
												/>

												<button type="button" className="password-toggle" onClick={() => setShowPassword(!showPassword)}>
													<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
														{showPassword ? (
															<path
																d="M17.94 17.94A10.07 10.07 0 0 1 12 20C7 20 2.73 16.39 1 12A18.45 18.45 0 0 1 5.06 5.06M9.9 4.24A9.12 9.12 0 0 1 12 4C17 4 21.27 7.61 23 12A18.5 18.5 0 0 1 19.42 16.42M14.12 14.12A3 3 0 1 1 9.88 9.88M1 1L23 23"
																stroke="currentColor"
																strokeWidth="2"
																strokeLinecap="round"
																strokeLinejoin="round"
															/>
														) : (
															<path d="M1 12S5 4 12 4S23 12 23 12S19 20 12 20S1 12 1 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
														)}
														<circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
													</svg>
												</button>
											</div>
											{errors.password && <span className="error-text">{errors.password}</span>}
										</div>

										<div className="form-group">
											<label htmlFor="confirmPassword" className="form-label">
												Confirm Password *
											</label>

											<input
												type="password"
												id="confirmPassword"
												className="form-input"
												value={values.confirmPassword}
												onChange={(e) => {
													setFieldValue("confirmPassword", e.target.value);
												}}
											/>
											{errors.confirmPassword && <span className="error-text">{errors.confirmPassword}</span>}
										</div>

										<div className="form-options align-items-start flex-column">
											<div className="form-check">
												<input
													type="checkbox"
													id="terms"
													className="form-check-input"
													checked={values?.termsAccepted}
													onChange={(e) => {
														setFieldValue("termsAccepted", e.target.checked);
													}}
												/>
												<label htmlFor="terms" className="form-check-label">
													I agree to the{" "}
													<Link to="/terms-of-service" className="link">
														Terms of Service
													</Link>{" "}
													and{" "}
													<Link to="/privacy-policy" className="link">
														Privacy Policy
													</Link>
												</label>
											</div>
											{errors.termsAccepted && <span className="error-text">{errors.termsAccepted}</span>}
										</div>
										<button type="button" className="submit-btn " disabled={singUpLoader} onClick={handleSubmit}>
											Create Account
										</button>
									</Form>
								);
							}}
						</Formik>

						<div className="form-footer">
							<p>
								Already have an account?{" "}
								<button className="link-btn" onClick={() => toggleTab("signin")}>
									Sign in
								</button>
							</p>
						</div>
					</div>
				</div>
			)}

			{screen === "NotMatch" && (
				<div className="form-section" style={{width: "100%", maxWidth: "100%"}}>
					<div>
						{/* <BackButton /> */}
						<h2 className="form-title">Business Verification Prompt</h2>
						<h6>Congrats, you have successfully signed up. Let's verify your business next.</h6>
					</div>

					<Button type="button" variant="contained" color="info" disabled={isLoader} fullWidth sx={{mb: 2}} onClick={sendOptEmail}>
						Skip
					</Button>
					{/* orientation={"vertical"} */}
					{/* Desktop: Horizontal Tabs */}
					{/* <div style={{width: "100%", overflow: "hidden"}} className="desktop-tabs">
						<Tabs
							value={tabValue}
							onChange={handleChange}
							variant="standard"
							sx={{
								mb: 3,
								width: "100%",
								display: {xs: "none", md: "flex"},
								"& .MuiTabs-flexContainer": {
									gap: "16px",
								},
								"& .MuiTab-root": {
									minWidth: "auto",
									padding: "12px 24px",
									fontSize: "1rem",
									textTransform: "none",
									fontWeight: 700,
								},
							}}>
							<Tab
								value="one"
								label={
									<span
										style={{
											fontWeight: 700,
											margin: 0,
											whiteSpace: "normal",
											textAlign: "left",
											display: "block",
											lineHeight: "1.4",
										}}>
										<span style={{display: "block"}}>Google Business Listing Verification</span>
										<span style={{fontSize: "0.75rem", fontWeight: 400, display: "block", marginTop: "4px"}}>(Highly Recommended)</span>
									</span>
								}
								wrapped
							/>
							<Tab
								value="two"
								label={
									<span
										style={{
											fontWeight: 700,
											margin: 0,
											whiteSpace: "normal",
											textAlign: "left",
											display: "block",
											lineHeight: "1.4",
										}}>
										Website & Domain Email Verification
									</span>
								}
								wrapped
							/>
						</Tabs>
					</div> */}

					<Tabs
						value={tabValue}
						onChange={handleChange}
						variant="standard"
						sx={{
							mb: 3,
							width: "100%",
							display: {xs: "none", md: "flex"},
							"& .MuiTabs-flexContainer": {
								gap: "16px",
								alignItems: "center",
							},
							"& .MuiTab-root": {
								minWidth: "auto",
								padding: "12px 24px",
								fontSize: "1rem",
								textTransform: "none",
								fontWeight: 700,
							},
						}}>
						<Tab
							value="one"
							label={
								<span style={{display: "block", lineHeight: 1.4}}>
									<span style={{display: "block", fontWeight: 700}}>Google Business Listing Verification</span>
									<span
										style={{
											fontSize: "0.75rem",
											fontWeight: 400,
											marginTop: 4,
											display: "block",
										}}>
										(Highly Recommended)
									</span>
								</span>
							}
							wrapped
						/>

						{/* 🔥 OR Divider */}
						<Box
							sx={{
								px: 1,
								color: "text.secondary",
								fontSize: "0.75rem",
								fontWeight: 600,
								letterSpacing: "0.08em",
								userSelect: "none",
							}}>
							OR
						</Box>

						<Tab value="two" label="Website & Domain Email Verification" wrapped />
					</Tabs>

					{/* Mobile: Vertical Tabs */}
					<div style={{width: "100%", display: "flex", flexDirection: "column", gap: "12px", marginBottom: "24px"}} className="mobile-tabs">
						<Button
							variant={tabValue === "one" ? "contained" : "outlined"}
							onClick={() => handleChange(null, "one")}
							sx={{
								display: {xs: "flex", md: "none"},
								width: "100%",
								padding: "16px 20px",
								fontSize: "1rem",
								fontWeight: 700,
								textTransform: "none",
								justifyContent: "flex-start",
								alignItems: "center",
								borderRadius: "8px",
								minHeight: "70px",
								"&.MuiButton-contained": {
									backgroundColor: "var(--primary-green)",
									color: "white",
									"&:hover": {
										backgroundColor: "#20c997",
									},
								},
								"&.MuiButton-outlined": {
									borderColor: "#e0e0e0",
									borderWidth: "2px",
									color: "#666",
									"&:hover": {
										borderColor: "var(--primary-green)",
										backgroundColor: "rgba(40, 168, 72, 0.05)",
									},
								},
							}}>
							<span style={{textAlign: "left", flex: 1, lineHeight: "1.4"}}>
								<span style={{display: "block", fontWeight: 700, marginBottom: "4px"}}>Google Business Listing Verification</span>
								<span style={{fontSize: "0.75rem", fontWeight: 400, opacity: 0.8}}>(Highly Recommended)</span>
							</span>
						</Button>
						<Typography align="center" sx={{my: 2, display: {xs: "block", md: "none"}, fontWeight: 700, fontSize: "0.875rem", color: "#666"}}>
							OR
						</Typography>
						<Button
							variant={tabValue === "two" ? "contained" : "outlined"}
							onClick={() => handleChange(null, "two")}
							sx={{
								display: {xs: "flex", md: "none"},
								width: "100%",
								padding: "16px 20px",
								fontSize: "1rem",
								fontWeight: 700,
								textTransform: "none",
								justifyContent: "flex-start",
								alignItems: "center",
								borderRadius: "8px",
								minHeight: "70px",
								"&.MuiButton-contained": {
									backgroundColor: "var(--primary-green)",
									color: "white",
									"&:hover": {
										backgroundColor: "#20c997",
									},
								},
								"&.MuiButton-outlined": {
									borderColor: "#e0e0e0",
									borderWidth: "2px",
									color: "#666",
									"&:hover": {
										borderColor: "var(--primary-green)",
										backgroundColor: "rgba(40, 168, 72, 0.05)",
									},
								},
							}}>
							<span style={{textAlign: "left", flex: 1, lineHeight: "1.4"}}>
								<span style={{display: "block", fontWeight: 700}}>Website & Domain Email Verification</span>
							</span>
						</Button>
					</div>

					{success && (
						<Alert severity="success" sx={{my: 2}}>
							{success}
						</Alert>
					)}
					{error && (
						<Alert severity="error" sx={{my: 2}}>
							{error}
						</Alert>
					)}

					{tabValue === "one" && (
						<Formik
							enableReinitialize
							initialValues={{
								googleListing: savedFormData?.googleListing || isGoogleListing || "",
								phone: savedFormData?.phone || normalizePhoneInput(userDetails.phone) || isPhone || "+1",
								email: savedFormData?.businessEmail || userDetails.email || isEmail || "",
							}}
							validationSchema={Yup.object({
								googleListing: Yup.string().url("Enter valid Google business link").required("Google Business Listing is required"),
								phone: Yup.string()
									.transform((value) => {
										if (!value || value.trim() === "" || value.trim() === "+1") {
											return null;
										}
										return value;
									})
									.nullable()
									.matches(/^\+\d{6,15}$/, "Enter valid phone number with country code (e.g. +14155550123)"),
								email: Yup.string().email("Enter valid email").required("Business email is required"),
							})}
							onSubmit={handleBusinessVerificationCheck}>
							{(props) => {
								const {setFieldValue, handleSubmit, resetForm, dirty, values, errors} = props;
								return (
									<Form noValidate>
										<span className="form-label" style={{fontWeight: 100, color: "#8e8e8eff", mb: 3}}>
											Provide your Google Business Listing where your phone and/or email matches the phone and/or email you provide.
										</span>

										<div className="form-group">
											<label htmlFor="googleListing" className="form-label">
												Google Business Listing * <br />
												<span style={{fontWeight: 100, color: "#8e8e8eff", fontSize: 12}}>
													(Copy and paste your Google Business Listing link here. If your business is not listed in Google, we recommend listing it)
												</span>
											</label>

											<input
												type="text"
												id="googleListing"
												className="form-input"
												placeholder="Enter Your Google Business Listing"
												value={values.googleListing}
												onChange={(e) => {
													setFieldValue("googleListing", e.target.value);
												}}
											/>
											{errors.googleListing && <span className="error-text">{errors.googleListing}</span>}
										</div>

										<div className="form-group">
											<label htmlFor="businessPhone" className="form-label">
												Business Email * <br />
												<span style={{fontWeight: 100, color: "#8e8e8eff", fontSize: 12}}>
													(Preferred email: matches your website domain. E.g., your website is mybusiness.com, your email is abc@mybusiness.com)
												</span>{" "}
											</label>
											<input
												type="text"
												id="email"
												className="form-input"
												placeholder="Enter your Business Email"
												value={values.email}
												onChange={(e) => {
													setFieldValue("email", e.target.value);
												}}
											/>
											{errors.email && <span className="error-text">{errors.email}</span>}
										</div>

										<div className="form-group">
											<label htmlFor="phone" className="form-label">
												Business Phone Number <span style={{fontWeight: 100, color: "#8e8e8eff", fontSize: 12}}>(cell/land as listed on your website)</span>
											</label>
											<input
												type="text"
												id="phone"
												className="form-input"
												placeholder="Enter your Business Phone  Ex. +1 (555) 123-4567"
												value={values.phone}
												onChange={(e) => {
													setFieldValue("phone", normalizePhoneInput(e.target.value));
												}}
											/>
											{errors.phone && <span className="error-text">{errors.phone}</span>}
										</div>

										<button type="button" className="submit-btn " disabled={isLoader} onClick={handleSubmit}>
											Verify
										</button>
									</Form>
								);
							}}
						</Formik>
					)}

					{tabValue === "two" && (
						<Formik
							enableReinitialize
							initialValues={{
								businessWebsite: savedFormData?.businessWebsite || isBusinessWebsite || "",
								email: savedFormData?.businessEmail || userDetails.email || isEmail || "",
							}}
							validationSchema={Yup.object({
								businessWebsite: Yup.string()
									.required("Business Website email is required")
									.test("valid-business-website", "Enter a valid business website (e.g. xyz.com)", (value) => {
										if (!value) return true; // Allow null / empty
										const pattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/;
										return pattern.test(value);
									}),
								email: Yup.string().email("Enter valid email").required("Business email is required"),
							})}
							onSubmit={handleBusinessVerificationCheck}>
							{(props) => {
								const {setFieldValue, handleSubmit, resetForm, dirty, values, errors} = props;
								return (
									<Form noValidate>
										<span className="form-label" style={{fontWeight: 100, color: "#8e8e8eff", mb: 2}}>
											Provide your business website and a matching domain email. i.e., your website: www.mycompany.com, your email: abc@mycompany.com (Your email has to be @mycompany, not @somethingelse).{" "}
										</span>

										<div className="form-group">
											<label htmlFor="businessWebsite" className="form-label">
												Business Website *
											</label>
											<input
												type="text"
												id="businessWebsite"
												className="form-input"
												placeholder="Enter your Business Website"
												value={values.businessWebsite}
												onChange={(e) => {
													setFieldValue("businessWebsite", e.target.value);
												}}
											/>
											{errors.businessWebsite && <span className="error-text">{errors.businessWebsite}</span>}
										</div>

										<div className="form-group">
											<label htmlFor="businessPhone" className="form-label">
												Business Email * <br />
											</label>
											<input
												type="text"
												id="email"
												className="form-input"
												placeholder="Enter your Business Email"
												value={values.email}
												onChange={(e) => {
													setFieldValue("email", e.target.value);
												}}
											/>
											{errors.email && <span className="error-text">{errors.email}</span>}
										</div>

										<button type="button" className="submit-btn " disabled={isLoader} onClick={handleSubmit}>
											Verify
										</button>
									</Form>
								);
							}}
						</Formik>
					)}
				</div>
			)}

			{screen === "EmailMatchFound" && (
				<div>
					<div className="form-section">
						{/* <BackButton /> */}
						<svg xmlns="http://www.w3.org/2000/svg" width="2.3em" height="2.3em" viewBox="0 0 16 16">
							<rect width="25" height="25" fill="none" />
							<path
								fill="#28A848"
								d="M15 2H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1M4.94 9.94l-3 3c-.12.12-.28.18-.44.18s-.32-.06-.44-.18a.63.63 0 0 1 0-.88l3-3c.24-.24.64-.24.88 0c.25.24.25.64 0 .88m10 3c-.12.12-.28.18-.44.18s-.32-.06-.44-.18l-3-3a.63.63 0 0 1 0-.88c.24-.24.64-.24.88 0l3 3c.25.24.25.64 0 .88m0-9L8.8 10.09c-.22.22-.51.33-.8.33s-.58-.11-.8-.33L1.06 3.94c-.24-.24-.24-.64 0-.88s.64-.24.88 0L8 9.12l6.06-6.06c.24-.24.64-.24.88 0c.25.24.25.64 0 .88"
							/>
						</svg>
						{/* <h2 className="form-title my-3">Email Match Found</h2>
						<h6 className="" style={{color: "#28A848", fontWeight: 800}}>
							{isEmail}
						</h6>
						<h6 className="my-3">Congrats, you have provided a matching domain-email address.</h6> */}

						<h2 className="form-title my-3">Email Match Found</h2>
						<h6 className="" style={{color: "#28A848", fontWeight: 800}}>
							{isEmail}
						</h6>
						{!emailTest ? (
							<>
								<h6 className="my-3">Congrats, you have provided a matching domain-email address.</h6>{" "}
							</>
						) : (
							<h6 className="my-3">{emailTest}</h6>
						)}
						{error && (
							<Alert severity="error" sx={{my: 2}}>
								{error}
							</Alert>
						)}
						<button type="button" className="submit-btn" onClick={sendOptEmail} disabled={isLoader}>
							Send Code to Email
						</button>
					</div>
				</div>
			)}

			{screen === "PhoneMatchFound" && (
				<div>
					<div className="form-section">
						{/* <BackButton /> */}
						<svg xmlns="http://www.w3.org/2000/svg" width="2.3em" height="2.3em" viewBox="0 0 1536 1536">
							<rect width="1536" height="1536" fill="none" />
							<path
								fill="#28A848"
								d="M1280 1065q0-11-2-16t-18-16.5t-40.5-25T1172 981t-45.5-25t-28.5-15q-5-3-19-13t-25-15t-21-5q-15 0-36.5 20.5t-39.5 45t-38.5 45T885 1039q-7 0-16.5-3.5T853 1029t-17-9.5t-14-8.5q-99-55-170-126.5T525 714q-2-3-8.5-14t-9.5-17t-6.5-15.5T497 651q0-13 20.5-33.5t45-38.5t45-39.5T628 503q0-10-5-21t-15-25t-13-19q-3-6-15-28.5T555 364t-26.5-47.5t-25-40.5t-16.5-18t-16-2q-48 0-101 22q-46 21-80 94.5T256 503q0 16 2.5 34t5 30.5t9 33t10 29.5t12.5 33t11 30q60 164 216.5 320.5T843 1230q6 2 30 11t33 12.5t29.5 10t33 9t30.5 5t34 2.5q57 0 130.5-34t94.5-80q22-53 22-101m256-777v960q0 119-84.5 203.5T1248 1536H288q-119 0-203.5-84.5T0 1248V288Q0 169 84.5 84.5T288 0h960q119 0 203.5 84.5T1536 288"
							/>
						</svg>
						<h2 className="form-title my-3">Phone Match Found</h2>
						<h6 className="" style={{color: "#28A848", fontWeight: 800}}>
							{isPhone}
						</h6>
						<h6 className="my-3">Congrats, your provided phone number matches your Google Business Listing phone number.</h6>

						{error && (
							<Alert severity="error" sx={{my: 2}}>
								{error}
							</Alert>
						)}
						<button type="button" className="submit-btn" onClick={sendOptPhone} disabled={isLoader}>
							Send Code to Phone
						</button>
					</div>
				</div>
			)}

			{screen === "EmailOtp" && (
				<div className="otp-verification-section">
					{/* <BackButton /> */}
					<div className="otp-header">
						<div className="otp-icon">
							<svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M22 2H2V22H22V2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
								<path d="M22 12H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
								<path d="M6 12H2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
								<path d="M12 6V2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
								<path d="M12 22V18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							</svg>
						</div>
						<h3 className="otp-title">Email verification</h3>
						<p className="otp-subtitle">
							We've sent a 6-digit code to <strong>{isEmail}</strong>.
						</p>
					</div>

					{error && (
						<Alert severity="error" sx={{my: 2}}>
							{error}
						</Alert>
					)}

					<Formik
						enableReinitialize
						initialValues={{
							otp: "",
						}}
						validationSchema={Yup.object({
							otp: Yup.string()
								.required("Verification code is required")
								.matches(/^\d{6}$/, "Code must be exactly 6 digits"),
						})}
						onSubmit={verifyOptEmail}>
						{(props) => {
							const {setFieldValue, handleSubmit, resetForm, dirty, values, errors} = props;
							return (
								<Form noValidate>
									<div className="form-group">
										<label htmlFor="otp" className="form-label">
											Verification Code
										</label>
										<input
											type="text"
											id="otp"
											className="form-input otp-input"
											placeholder="123456"
											maxLength="6"
											onChange={(e) => {
												const value = e.target.value.replace(/\D/g, "");
												setFieldValue("otp", value);
											}}
											value={values.otp}
										/>
										{errors.otp && <p className="error-text">{errors.otp}</p>}
									</div>
									<button type="button" className="submit-btn" onClick={handleSubmit} disabled={isLoader}>
										Verify Code
									</button>
								</Form>
							);
						}}
					</Formik>

					<div className="otp-actions">
						<button type="button" className="resend-btn" disabled={isLoader} onClick={sendOptEmail}>
							Didn't receive code? Resend
						</button>
					</div>
				</div>
			)}

			{screen === "PhoneOtp" && (
				<div className="otp-verification-section">
					{/* <BackButton /> */}
					<div className="otp-header">
						<div className="otp-icon">
							<svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M22 2H2V22H22V2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
								<path d="M22 12H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
								<path d="M6 12H2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
								<path d="M12 6V2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
								<path d="M12 22V18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							</svg>
						</div>
						<h3 className="otp-title">Enter Verification Code</h3>
						<p className="otp-subtitle">
							We've sent a 6-digit code to <strong>{isPhone}</strong>
						</p>
					</div>
					{error && (
						<Alert severity="error" sx={{my: 2}}>
							{error}
						</Alert>
					)}

					<Formik
						enableReinitialize
						initialValues={{
							otp: "",
						}}
						validationSchema={Yup.object({
							otp: Yup.string()
								.required("Verification code is required")
								.matches(/^\d{6}$/, "Code must be exactly 6 digits"),
						})}
						onSubmit={verifyOptPhone}>
						{(props) => {
							const {setFieldValue, handleSubmit, resetForm, dirty, values, errors} = props;
							return (
								<Form noValidate>
									<div className="form-group">
										<label htmlFor="otp" className="form-label">
											Verification Code
										</label>
										<input
											type="text"
											id="otp"
											className="form-input otp-input"
											placeholder="123456"
											maxLength="6"
											onChange={(e) => {
												const value = e.target.value.replace(/\D/g, "");
												setFieldValue("otp", value);
											}}
											value={values.otp}
										/>
										{errors.otp && <p className="error-text">{errors.otp}</p>}
									</div>
									<button type="button" className="submit-btn" disabled={isLoader} onClick={handleSubmit}>
										Verify Code
									</button>
								</Form>
							);
						}}
					</Formik>

					<div className="otp-actions">
						<button type="button" className="resend-btn" onClick={sendOptPhone}>
							Didn't receive code? Resend
						</button>
					</div>
				</div>
			)}

			{screen === "BusinessVerifiedSuccessfully" && (
				<div className="tab-content-wrapper">
					<div className="form-section text-center">
						<h2 className="form-title">Business Verified</h2>
						<p className="form-subtitle">{"Your business has been verified successfully."}</p>
						<div className="my-4 d-flex flex-column align-items-center gap-3">
							<div className="verified-badge p-3 px-4 mx-3" style={{fontSize: "18px", display: "inline-flex", alignItems: "center", gap: "10px"}}>
								<span style={{fontSize: "22px"}}>✔</span>
								<span>Business Verified</span>
							</div>
							<p className="text-muted" style={{maxWidth: 360}}>
								You’re all set. Head over to your dashboard to manage your profile, ratings, and business details.
							</p>
						</div>
						<Stack direction={{xs: "column", sm: "row"}} spacing={2} justifyContent="center">
							<button
								type="button"
								className="submit-btn"
								onClick={() => {
									window.location.href = "/contractor-dashboard";
								}}>
								Go to Dashboard
							</button>
							<button
								type="button"
								className="submit-btn"
								onClick={() => {
									window.location.href = "/";
								}}>
								Lookup Addresses
							</button>
						</Stack>
					</div>
				</div>
			)}
		</div>
	);
};
